import * as React from 'react';
import { useContext } from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { ODIcon } from '../../DoctorMangement/ODIcon';
import { resetPassowrdForUser } from "../Helper/API"
import { ToastEmitter } from '../../DoctorMangement/ToastEmitter';
import { BackdropLoader } from '../../DoctorMangement/BackdropLoader';
import UserFeaturesContext from '../../../hook/UserDetails/UserFeaturesContext';
import { FEATURE_NAME } from '../../DoctorMangement/constant';
import { checkFeatureFeasbility } from '../../../helper/utils';
export const MenuListComposition = ({ createdOn, createdBy, userName, entityId }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const { userFeatures } = useContext(UserFeaturesContext);

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleResetPassword = async ()=>{
        try{
            setIsLoading(true)
            const resp = await resetPassowrdForUser(userName, entityId);
            ToastEmitter(`Password Reset Link has be sent to the registered Email Id ${resp.emailId}`)
        }
        catch (err){
            ToastEmitter("Unable To reset password Please Try after some time", 'error')
        }
        finally{
            setIsLoading(false);
        }
    }

    return (
        
        <React.Fragment>
           {isLoading &&  <BackdropLoader isLoading={isLoading}/>} 
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <MoreVertIcon />
                    </IconButton>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                className='text-s text-[#47566A] text-light'
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 14,
                                width: 10,
                                height: 10,
                                bgcolor: 'background.paper',
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                { checkFeatureFeasbility(FEATURE_NAME.RESET_PASSWORD, userFeatures) && <>
                    <MenuItem onClick={handleResetPassword}>
                        <ListItemIcon>
                            <ODIcon src={'/assets/lock.svg'} width={20} height={20} />

                        </ListItemIcon>
                        Reset Password
                    </MenuItem>
                    {false && <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                            <ODIcon src={'/assets/trash.svg'} width={20} height={20} />
                        </ListItemIcon>
                        Delete
                    </MenuItem>
                    }
                    <Divider />
                </>
                }
                <MenuItem onClick={handleClose}>
                    <div className="flex flex-col justify-start gap-2">
                        <p> Created By</p>
                        <div className="flex flex-row gap-2 justify-start">
                            <ODIcon src={'/assets/ProfilePlaceholder.svg'} width={40} height={40} className={'flex items-center justify-center rounded-full'} alt="Placeholder" />
                            <p className="flex flex-col align-center justify-center  content-center">
                                {createdBy}
                                <p className="text-xs text-[#47566A]">{moment(createdOn).format('DD-MMM-YYYY, h:mm a')}</p>
                            </p>
                        </div>
                    </div>
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}